<!--
 * @Auther: 罗耀祖
 * @Date: 2021-07-13 17:01:16
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2021-07-14 17:39:16
 * @name: 品牌系列型号管理表格视口
 * @Description: 品牌系列型号管理表格视口
 * @FilePath: \backstage\src\components\modelGoodsManage\layout.vue
 * @Author: DESKTOP-1QU67QM
-->
<template>
  <table-normal class="table">
    <template v-slot:head>
      <div class="head">
        <slot name="head" />
      </div>
    </template>
    <template v-slot:bar>
      <div class="bar" v-if="step > 1">
        <slot name="bar" />
      </div>
    </template>
    <template v-slot:table>
      <slot name="table" />
    </template>
    <template v-slot:pagination>
      <div class="pagination">
        <slot name="pagination" />
      </div>
    </template>
  </table-normal>
</template>
<script>
import tableNormal from "@/components/public/table-normal.vue";

export default {
  name: "modelGoodsManage-layout",
  components: {
    tableNormal,
  },
  props: {
    step: {
      type: Number,
    },
  },
};
</script>
<style lang="scss" scoped>
.table {
  margin: 0;
}
</style>